import { render, staticRenderFns } from "./MarronsStart.vue?vue&type=template&id=42983acc&"
import script from "./MarronsStart.vue?vue&type=script&lang=js&"
export * from "./MarronsStart.vue?vue&type=script&lang=js&"
import style0 from "./MarronsStart.vue?vue&type=style&index=0&id=42983acc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports